import React, { Component } from 'react';

import LeafletMapPlaces from '../b-LeafletMap/LeafletMapPlaces';

class PlacesProfile extends React.Component {
  constructor(props) {
    super(props);
    var areas_by_reason = props.territory.areas_by_reason;
    var all_residential_areas = [];
    props.territory.communes.map((c) => all_residential_areas = all_residential_areas.concat(c.residential_areas))

    this.state = {
      areas_by_reason: areas_by_reason,
      residential_areas: all_residential_areas,
      selected: {
        reason_name: areas_by_reason[0].name,
        areas: areas_by_reason[0].areas
      }
    };
  }

  displayCategory = (name, areas) => {
    this.setState({
      selected: {
        reason_name: name,
        areas: areas
      }
    });
  }

  render() {
    return(
          <div className="row content mt-4 mb-5">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">lieux de vie</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 line-border">
                  {this.state.areas_by_reason.filter((c) => c.name != "accompany").map((c) =>
                    <p className={c.name === this.state.selected.reason_name ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                       onClick={this.displayCategory.bind(this, c.name, c.areas)}
                       id={c.name}>{c.name_fr}</p>
                  )}
                  </div>
                </div>
            </div>

            <div className="col-9 mt-3">
              <div className="row">
                <div className="col-12">
                    <LeafletMapPlaces residential_areas={this.state.residential_areas}
                                      areas={this.state.selected.areas}
                                      id="places_profile_map"/>
                </div>
              </div>
            </div>

          </div>
    )
  }
}

export default PlacesProfile;
